module.exports = __webpack_public_path__ + "static/media/pool.939f1f6c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/pool.svg
// module id = 393
// module chunks = 7